import apiService from '../service/ApiService';
import { INTERNAL_ROUTES } from '../static/Urls';
import ApiKey from '@shared/api/dto/ApiKey';
import { reportActionEvent } from '../tracking/tracking';

const apiKeyApiUrl = INTERNAL_ROUTES.API_PATH + '/api/apikeys';

const fetchApiKeys = (): Promise<ApiKey[]> => {
  return apiService.callGet<ApiKey[]>(apiKeyApiUrl, { withCredentials: true }, undefined, {
    doReturn: () => [],
  });
};

const doOnSuccess = (response: ArrayBuffer | undefined) => {
  if (response) {
    reportActionEvent({
      completePath: 'is24.de.api.self-service-portal',
      name: 'sandbox_apikey_deleted',
    });
  }
};

const deleteApiKey = (apiKey: string) => {
  return apiService.callPost(apiKeyApiUrl + `/${apiKey}`, undefined, { withCredentials: true }, { doOnSuccess });
};

const apiKeysApi = {
  fetch: fetchApiKeys,
  delete: deleteApiKey,
};

export default apiKeysApi;
